import React from 'react';

import { Box, ButtonBase, Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { AiOutlineClose } from 'react-icons/ai';
import { FaSignOutAlt, FaUsers } from 'react-icons/fa';
import { GiHamburgerMenu } from 'react-icons/gi';
import { MdHelp, MdPerson } from 'react-icons/md';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { Link } from 'react-router-dom';

import QuickRPIcon from 'assets/quick_icon.svg';
import ForgotPasswordIcon from 'components/atoms/ForgotPasswordIcon';
import { TypographyCN } from 'components/atoms/Typograph';
import { IconContext } from 'components/IconContext';
import { theme } from 'styles';
import { FuncionarioType } from 'types/graphql';

import styled from 'styled-components';

const useStyles = makeStyles({
  list: {
    width: '100vw',
  },
  fullList: {
    width: 'auto',
  },
});

type Anchor = 'top' | 'bottom' | 'right' | 'left';

interface DrawerMobileProps {
  data: FuncionarioType | undefined;
  navbarData: {
    id: number;
    name: string;
    icon: React.ReactElement;
    data: {
      id: number;
      name: string;
      url: string;
      icon: React.ReactElement;
    }[];
  }[];
  onExit: () => void;
  handleMenu: any;
  handleOpenDrawerPassword: () => void;
}

export function DrawerMobile({ data, navbarData, onExit, handleMenu, handleOpenDrawerPassword }: DrawerMobileProps) {
  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    bottom: false,
    right: false,
    left: false,
  });

  const [openGed, setOpenGed] = React.useState(false);
  const [openPdv, setOpenPdv] = React.useState(false);
  const [openCrm, setOpenCrm] = React.useState(false);
  const [openBpm, setOpenBpm] = React.useState(false);

  const toggleDrawer = (anchor: Anchor, open: boolean, isChangePassord?: boolean) => (
    event: React.KeyboardEvent | React.MouseEvent,
  ) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    if (isChangePassord) handleOpenDrawerPassword();
    setState({ ...state, [anchor]: open });
    setOpenGed(false);
    setOpenPdv(false);
    setOpenCrm(false);
    setOpenBpm(false);
  };

  const iconChangeGed = !openGed ? <MdKeyboardArrowDown size={30} /> : <MdKeyboardArrowUp size={30} />;
  const iconChangePdv = !openPdv ? <MdKeyboardArrowDown size={30} /> : <MdKeyboardArrowUp size={30} />;
  const iconChangeCrm = !openCrm ? <MdKeyboardArrowDown size={30} /> : <MdKeyboardArrowUp size={30} />;
  const iconChangeBpm = !openBpm ? <MdKeyboardArrowDown size={30} /> : <MdKeyboardArrowUp size={30} />;

  const handleClickGed = () => {
    setOpenGed(!openGed);
    !!openPdv && setOpenPdv(!openPdv);
    !!openCrm && setOpenCrm(!openCrm);
    !!openBpm && setOpenBpm(!openBpm);
  };

  const handleClickPdv = () => {
    !!openGed && setOpenGed(!openGed);
    setOpenPdv(!openPdv);
    !!openCrm && setOpenCrm(!openCrm);
    !!openBpm && setOpenBpm(!openBpm);
  };

  const handleClickCrm = () => {
    !!openGed && setOpenGed(!openGed);
    !!openPdv && setOpenPdv(!openPdv);
    setOpenCrm(!openCrm);
    !!openBpm && setOpenBpm(!openBpm);
  };

  const handleClickBpm = () => {
    !!openGed && setOpenGed(!openGed);
    !!openPdv && setOpenPdv(!openPdv);
    !!openCrm && setOpenCrm(!openCrm);
    setOpenBpm(!openBpm);
  };

  const navBarValue = state['right'] === true;
  const changeNavBarMenu = navBarValue ? (
    <AiOutlineClose size={32} color="#FFFFFF" />
  ) : (
    <GiHamburgerMenu size={32} color="#FFFFFF" />
  );

  const handlePasswordClick = (anchor: Anchor) => {
    toggleDrawer(anchor, false);
  };

  const list = (anchor: Anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        paddingBottom: 40,
        justifyContent: 'space-between',
      }}
      role="presentation"
    >
      <Grid
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Grid
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '0.5rem',
            // paddingLeft: 20,
            paddingRight: 20,
          }}
        >
          <Button onClick={navBarValue ? toggleDrawer(anchor, false) : toggleDrawer(anchor, true)} disableRipple>
            <AiOutlineClose size={32} color="#FFFFFF" />
          </Button>
          <Box
            style={{
              position: 'absolute',
              left: '50%',
              transform: 'translate(-50%, 0)',
            }}
          >
            <img
              src={QuickRPIcon}
              alt="QuickRPIcon"
              style={{
                padding: '0.5rem',
                width: '7rem',
              }}
            />
          </Box>
          {/* <Box style={{ width: '5rem', }}/> */}
        </Grid>
        <ButtonBase
          style={{
            gap: 20,
            width: '100%',
            flexDirection: 'row-reverse',
            justifyContent: 'start',
            paddingRight: 10,
            paddingLeft: 20,
            marginTop: '2rem',
          }}
        >
          <TypographyCN
            color="inherit"
            weight="medium"
            style={{
              fontSize: 18,
              padding: 0,
              whiteSpace: 'nowrap',
            }}
          >
            {Number(data?.nome?.length) > 20 ? `${data?.nome?.slice(0, 20)}...` : data?.nome}
          </TypographyCN>

          <div
            style={{
              width: 40,
              height: 40,
            }}
          >
            <MdPerson
              color="white"
              // size={35}
              style={{
                width: '100%',
                height: '100%',
                border: '2px solid white',
                borderRadius: '50px',
                marginRight: '3rem',
              }}
            />
          </div>
        </ButtonBase>

        <Grid
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 15,
            alignItems: 'start',
            paddingTop: 30,
            paddingLeft: 20,
          }}
        >
          {navbarData.map(e => (
            <>
              {e.id === 1 && (
                <div key={e.id}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '1rem',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        width: '180px',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        background: 'white',
                        padding: '0.25rem 0.5rem',
                        borderRadius: 8,
                      }}
                      onClick={() => {
                        handleClickGed();
                      }}
                      role="button"
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          gap: 2,
                        }}
                      >
                        {e.icon}
                        <span
                          style={{
                            fontSize: 18,
                            fontWeight: 900,
                            color: theme.palette.primary.main,
                            margin: '0 0.875rem',
                          }}
                        >
                          {e.name}
                        </span>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          border: 'none',
                          background: 'transparent',
                          color: theme.palette.primary.main,
                          fontSize: '1.25rem',
                          padding: 0,
                        }}
                      >
                        {iconChangeGed}
                      </div>
                    </div>

                    {!!openGed && (
                      <>
                        {e.data.map(e => (
                          <Link
                            style={{
                              textDecoration: 'none',
                              color: '#ffffff',
                              display: 'flex',
                              justifyContent: 'start',
                              alignItems: 'center',
                              width: '100%',
                              paddingLeft: 10,
                            }}
                            to={e.url}
                            key={e.id}
                            onClick={toggleDrawer(anchor, false)}
                            onKeyDown={toggleDrawer(anchor, false)}
                          >
                            {e.icon}

                            <TypographyCN
                              weight="simple"
                              color="inherit"
                              style={{
                                fontSize: 18,
                                minWidth: '15px',
                                marginLeft: 10,
                              }}
                            >
                              {e.name}
                            </TypographyCN>
                          </Link>
                        ))}
                      </>
                    )}
                  </div>
                </div>
              )}

              {e.id === 2 && (
                <div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '1rem',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        width: '180px',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        background: 'white',
                        padding: '0.25rem 0.5rem',
                        borderRadius: 8,
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        handleClickPdv();
                      }}
                      role="button"
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          gap: 2,
                        }}
                      >
                        {e.icon}
                        <span
                          style={{
                            fontSize: 18,
                            fontWeight: 900,
                            color: theme.palette.primary.main,
                            margin: '0 0.875rem',
                          }}
                        >
                          {e.name}
                        </span>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          border: 'none',
                          background: 'transparent',
                          color: theme.palette.primary.main,
                          fontSize: '1.25rem',
                          padding: 0,
                        }}
                      >
                        {iconChangePdv}
                      </div>
                    </div>

                    {!!openPdv && (
                      <>
                        {e.data.map(e => (
                          <Link
                            style={{
                              textDecoration: 'none',
                              color: '#ffffff',
                              display: 'flex',
                              justifyContent: 'start',
                              alignItems: 'center',
                              width: '100%',
                              paddingLeft: 10,
                            }}
                            to={e.url}
                            key={e.id}
                            onClick={toggleDrawer(anchor, false)}
                            onKeyDown={toggleDrawer(anchor, false)}
                          >
                            {e.icon}

                            <TypographyCN
                              weight="simple"
                              color="inherit"
                              style={{
                                fontSize: 18,
                                minWidth: '15px',
                                marginLeft: 10,
                              }}
                            >
                              {e.name}
                            </TypographyCN>
                          </Link>
                        ))}
                      </>
                    )}
                  </div>
                </div>
              )}

              {e.id === 3 && (
                <div key={e.id}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '1rem',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        width: '180px',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        background: 'white',
                        padding: '0.25rem 0.5rem',
                        borderRadius: 8,
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        handleClickCrm();
                      }}
                      role="button"
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          gap: 2,
                        }}
                      >
                        {e.icon}
                        <span
                          style={{
                            fontSize: 18,
                            fontWeight: 900,
                            color: theme.palette.primary.main,
                            margin: '0 0.875rem',
                          }}
                        >
                          {e.name}
                        </span>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          border: 'none',
                          background: 'transparent',
                          color: theme.palette.primary.main,
                          fontSize: '1.25rem',
                          padding: 0,
                        }}
                      >
                        {iconChangeCrm}
                      </div>
                    </div>

                    {!!openCrm && (
                      <>
                        {e.data.map(e => (
                          <Link
                            style={{
                              textDecoration: 'none',
                              color: '#ffffff',
                              display: 'flex',
                              justifyContent: 'start',
                              alignItems: 'center',
                              width: '100%',
                              paddingLeft: 10,
                            }}
                            to={e.url}
                            key={e.id}
                            onClick={toggleDrawer(anchor, false)}
                            onKeyDown={toggleDrawer(anchor, false)}
                          >
                            {e.icon}

                            <TypographyCN
                              weight="simple"
                              color="inherit"
                              style={{
                                fontSize: 18,
                                minWidth: '15px',
                                marginLeft: 10,
                              }}
                            >
                              {e.name}
                            </TypographyCN>
                          </Link>
                        ))}
                      </>
                    )}
                  </div>
                </div>
              )}

              {e.id === 4 && (
                <div key={e.id}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '1rem',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        width: '180px',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        background: 'white',
                        padding: '0.25rem 0.5rem',
                        borderRadius: 8,
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        handleClickBpm();
                      }}
                      role="button"
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          gap: 2,
                        }}
                      >
                        {e.icon}
                        <span
                          style={{
                            fontSize: 18,
                            fontWeight: 900,
                            color: theme.palette.primary.main,
                            margin: '0 0.875rem',
                          }}
                        >
                          {e.name}
                        </span>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          border: 'none',
                          background: 'transparent',
                          color: theme.palette.primary.main,
                          fontSize: '1.25rem',
                          padding: 0,
                        }}
                      >
                        {iconChangeBpm}
                      </div>
                    </div>

                    {!!openBpm && (
                      <>
                        {e.data.map(e => (
                          <Link
                            style={{
                              textDecoration: 'none',
                              color: '#ffffff',
                              display: 'flex',
                              justifyContent: 'start',
                              alignItems: 'center',
                              width: '100%',
                              paddingLeft: 10,
                            }}
                            to={e.url}
                            key={e.id}
                            onClick={toggleDrawer(anchor, false)}
                            onKeyDown={toggleDrawer(anchor, false)}
                          >
                            {e.icon}

                            <TypographyCN
                              weight="simple"
                              color="inherit"
                              style={{
                                fontSize: 18,
                                minWidth: '15px',
                                marginLeft: 10,
                              }}
                            >
                              {e.name}
                            </TypographyCN>
                          </Link>
                        ))}
                      </>
                    )}
                  </div>
                </div>
              )}
            </>
          ))}
        </Grid>
      </Grid>
      <Grid
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
          paddingLeft: 20,
        }}
      >
        <FooterButtons
          variant="text"
          disableRipple
          onClick={() => {
            window.open('https://quickerp.freshdesk.com', '_blank');
          }}
          onKeyDown={() => {
            window.open('https://quickerp.freshdesk.com', '_blank');
          }}
        >
          <IconContext icon={<MdHelp fill="#FFFFFF" size={26} />} className="icon" />
          <span className="menu-text-bottom">Ajuda</span>
        </FooterButtons>
        <FooterButtons
          variant="text"
          disableRipple
          onClick={toggleDrawer(anchor, false, true)}
          onKeyDown={toggleDrawer(anchor, false)}
        >
          <IconContext icon={<ForgotPasswordIcon fill="#FFFFFF" height="26" width="26" />} className="icon" />

          <span className="menu-text-bottom">Alterar Senha</span>
        </FooterButtons>

        <Link
          style={{
            textDecoration: 'none',
            color: '#ffffff',
            display: 'flex',
            gap: 20,
            alignItems: 'center',
            width: '100%',
            paddingRight: '10px',
          }}
          to="/dashboard"
          onClick={onExit}
        >
          <IconContext icon={<FaSignOutAlt color="#ffffff" />} className="icon" />

          <span
            style={{
              fontSize: 16,
              fontWeight: 700,
              minWidth: '15px',
              lineHeight: '20px',
            }}
          >
            Sair
          </span>
        </Link>
      </Grid>
    </div>
  );

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'start',
      }}
    >
      {(['right'] as Anchor[]).map(anchor => (
        <React.Fragment key={anchor}>
          <Button
            onClick={navBarValue ? toggleDrawer(anchor, false) : toggleDrawer(anchor, true)}
            style={{
              justifyContent: 'start',
            }}
          >
            {changeNavBarMenu}
          </Button>
          <Drawer anchor="left" open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}

const FooterButtons = styled(Button)`
  text-transform: none;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: start;
  gap: 20px;
  align-items: center;
  width: 100%;
  margin-left: -10px;
  padding-right: 10px;
  .menu-text-bottom {
    font-size: 16px;
    font-weight: 700;
    margin-left: 20px;
    min-width: 15px;
    line-height: 20px;
  }
`;
